export default "__VITE_ASSET__BfDJ0sWT__"